import { useUniqueInlineId } from '@inline-svg-unique-id/react'
import React from 'react'
import { SVGIconProps } from '../types'
const SvgHawkT1 = function ({ size = 16, ...props }: SVGIconProps) {
  const _id = useUniqueInlineId()
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={size}
      height={size}
      viewBox="0 0 200 56"
      fill="currentColor"
      {...props}
    >
      <defs>
        <path
          id={_id}
          d="M2.648 0h7.316c2.441 0 7.964 1.528 13.023 6.401l.472.46c3.151 3.055 9.69 9.027 14.61 13.49l6.246 5.644c.139.11 3.078 2.379 7.558 2.23v.908l28.882-3.146c.15-.027 3.51-.624 8.86-1.315l-1.525-3.308h2.039l2.132 2.979.26-.032c4.458-.528 9.9-1.064 15.826-1.412l.469-.027.75 1.851-.75-1.853q.586-.034 1.184-.063l1.2-.058.002.002.793-.035c2.653-.116 5.38-.19 8.136-.202l.97-.002h.235q.498.002.995.006l1.075.01 1.016.017.452.01.77.019.924.027 1.18.042 1.114.048.491.024.808.043.564.033.812.05.846.058c.186.015.371.02.554.037q.804.06 1.61.15l.538.062c8.186.994 16.465 4.05 23.105 7.114l.32.148q.903.422 1.758.834l.423.205.443.22c4.473 2.218 7.917 4.267 9.646 5.344l.936.589.304.198.228.066-1.56 1.668 1.563-1.668 3.119.904c11.708 3.409 20.485 6.18 23.497 8.657q.668.548.947 1.079l.048.1q.03.063.052.128l.021.064.015.05q.05.18.05.36c0 .419-.283.868-1.04 1.307l-.093.052-.076.041-.157.08c-2.657 1.31-9.801 2.49-26.501 2.49l-2.222-.002c-25.292-.046-100.654-.816-129.035-1.503l-.872-.022q-2-.05-3.882-.11l-1.25 3.822-12.073-2.185-.633-2.288-1.039-.067q-.767-.051-1.501-.104l-1.664 1.821h-.905l.783-1.953-.287-.022c-1.107.678-3.128 1.409-3.759 1.409-.57 0-2.34-1.243-3.456-2.071l-.973-.108c-4.458-.505-6.897-.95-7.754-1.121l-.357-.075V34.647l.355-.039 8.949-3.846zM1.096 37.876v9.637H0v-9.637zM158.99 53.178l-.975.796h-4.176l-.865-.796zm28.297-12.932.94 2.46L186.06 42v-1.754z"
        />
      </defs>
      <use xlinkHref={`#${_id}`} fill="#3E5667" fillRule="evenodd" />
    </svg>
  )
}
export default SvgHawkT1
